export enum StripeMetricsContext {
  GET_REDIRECT_URL = 'stripe_get_redirect_url',
  REDIRECT = 'stripe_redirect',
}
